import React, { useContext } from "react";
import { Context } from "../AppContext";
import { navigate } from "gatsby";

export default function useAuth() {
  const app = useContext(Context);

  const isBrowser = typeof window !== "undefined";

  const isLogin = () => {
    if (!isBrowser) return false;
    return !!window.localStorage.getItem("token");
  };

  const handleUnauthenticated = () => {
    if (!isLogin()) {
      navigate("/");
    }
  };

  const handleUnauthenticatedWithLoginModal = (page = "/orders") => {
    if (isLogin()) {
      navigate(page);
    } else {
      app.actions.setLoginModal(true);
    }
  };

  return {
    isLogin,
    handleUnauthenticated,
    handleUnauthenticatedWithLoginModal,
  };
}
